import * as React from "react";
import Component from "../../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import { PageTransition } from "../../../Partials/Spinner/PageTransition";
import { PromptDialog } from "../../../Partials/Dialog/PromptDialog";
import Button from '@material-ui/core/Button';

import { NewCoachHeader } from "./NewCoachHeader";
import { NewCoachBody } from "./NewCoachBody";
import { NewCoachButton } from "./NewCoachButton";

export class NewCoachWrapper extends Component {
  public defaultState: any = {
    isSaving: false,
    isClosePreprocessDialogOpen: false,
  }
  
  public state = {
    ...this.defaultState
  };

  constructor(public props) {
    super(props);
  }

  public onCloseCoachWithX = () => {
    this.setState({
      isClosePreprocessDialogOpen: true
    })
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public closeDialogAndCoach = () => {
    this.closePreprocessDilaogOpen();
    this.props.onCloseCoach();
  }

  public renderContent = () => {
    const { steps, onPageChange, onCloseCoach, showBackButton, disabled, disabledBack, disabledNext, onNext } = this.props;
    const { activeStep } = this.props.state;

    return (
      <React.Fragment>
        {
          activeStep !== steps?.length &&
          <NewCoachHeader activeStep={activeStep} steps={steps} onClose={this.onCloseCoachWithX} disabled={disabled} />
        }

        <NewCoachBody>
          {this.props.oldCoach ? this.props.content(activeStep) : this.props.stepContentArr[activeStep]}
        </NewCoachBody>

      { activeStep !== steps.length &&
        <NewCoachButton
          activeStep={activeStep}
          steps={steps}
          onPageChange={onPageChange}
          onCloseCoach={onCloseCoach}
          onNext={onNext}
          trans={this.trans}
          showBackButton={showBackButton}
          disabledBack={disabledBack}
          disabledNext={disabledNext}
          forelastNextButton={this.props?.forelastNextButton}
        />
      }
    </React.Fragment>
    )
  }

  public render() {
    return (
      <>
        <Dialog
          className={`dialog dialog-assistant coach-full-screen-presentation has-button-padding ${this.props.innerDialogClasses}`}
          open={this.props.openCoach}
          onClose={this.closeDialogAndCoach}
          disableBackdropClick={true}
          fullScreen
        >
          {this.renderContent()}
        </Dialog>

        <PageTransition isSaving={this.state.isSaving} />

        <PromptDialog
          {...this.props}
          innerDialogClasses="are-you-sure-dialog"
          title={this.trans("discard-changes")}
          content={
            <div>
              {this.trans("warning-data-may-be-lost")}
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
                key="modal-cancel-btn"
                color="primary"
                onClick={this.closePreprocessDilaogOpen}
                style={{height: "34px", width: "auto" }}
              >
                {this.trans("button-cancel")}
              </Button>
            ),
            (
              <Button
                key="modal-add-btn"
                variant="contained"
                color="primary"
                onClick={this.closeDialogAndCoach}
                style={{height: "34px", width: "auto" }}
              >
                {this.trans("button-discard")}
              </Button>
            )]
          }
        />
      </>
    );
  }
}
